<div class="move-okr-modal-wrapper" data-test-id="move-okrs">
  <div class="metric-wrapper" *ngIf="!isObjective">
    <i class="fs-16px" uiTheme="fill" uiType="metric" ui-icon></i>
    <span class="sp-ml-5 fs-16px font-mediumbold">{{ metric.name }}</span>
  </div>

  <div class="goal-wrapper" *ngIf="isObjective">
    <i class="fs-16px" uiTheme="fill" uiType="goal" ui-icon></i>
    <span class="sp-ml-5 fs-16px font-mediumbold">{{ goal.name }}</span>
  </div>

  <p class="sp-pt-20 sp-mb-4 fs-12px text-color-gray-13">{{ "move_to" | localize }}</p>

  <!-- Goal selector -->

  <div class="open-goal-selector-wrapper sp-mb-24" (click)="openGoalSelector()" data-test-id="open-goal-selector-modal-clone">
    <div class="selected-goal-input cursor-pointer fs-14px" *ngIf="isObjective ? !selectedModalOptions.goal && !selectedModalOptions.session : !selectedModalOptions.goal">
      {{ (isObjective ? "search_session_okr" : "search_okr") | localize }}
    </div>

    <div class="selected-goal-input cursor-pointer" *ngIf="selectedModalOptions.goal">
      <i class="fs-16px" uiTheme="fill" uiType="goal" ui-icon></i>
      <span class="sp-ml-5 text-color-gray-13 fs-14px" ui-typography uiEllipsis>{{ selectedModalOptions.goal.name }}</span>
    </div>
  </div>

  <!-- Selected session  -->
  <p class="sp-mb-4 sp-mt-20 text-color-gray-13 fs-12px" *ngIf="selectedModalOptions.goal">{{ "in_session" | localize }}</p>

  <div class="selected-goal-input cursor-pointer" *ngIf="selectedModalOptions.session && !selectedModalOptions.goal && !chooseBetweenSessions" (click)="openGoalSelector()">
    <i class="fs-16px" uiTheme="fill" uiType="session" ui-icon></i><span class="sp-ml-5 text-color-gray-13 fs-14px" ui-typography uiEllipsis>{{ selectedModalOptions.session.title }}</span>
  </div>

  <div class="selected-goal-input non-selectable-session" *ngIf="selectedModalOptions.session && selectedModalOptions.goal && !chooseBetweenSessions">
    <i class="fs-16px" uiTheme="fill" uiType="session" ui-icon></i><span class="sp-ml-5 text-color-gray-13 fs-14px" ui-typography uiEllipsis>{{ selectedModalOptions.session.title }}</span>
  </div>

  <gh-session-selector
    *ngIf="selectedModalOptions.goal && chooseBetweenSessions && invokerType === 'okr'"
    [currentSession]="validSessions[0]"
    [parentItem]="selectedModalOptions.goal"
    [value]="validSessions[0]?.id"
    [borderless]="false"
    (sessionSelect)="changeSession($event)"
    a11yLabelledby="session-label"></gh-session-selector>

  <!-- Checkbox -->

  <div class="sp-mt-20 sp-mb-24" *ngIf="isObjective">
    <label class="font-medium" [(ngModel)]="selectedModalOptions.moveChildren" ui-checkbox uiValue="moveChildren">{{ "move_child_okrs" | localize }}</label>
    <div class="sp-mt-2 sp-pl-24 text-color-gray-9 fs-14px">{{ "move_child_okrs_info" | localize }}</div>
  </div>
</div>
